/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.link-external\":\"Firkant med pil som peker oppover mot høyre\"}");